export enum ValidationConstraintEnum {
    IS_POSITIVE = 'IsPositive',
    IS_NUMBER = 'IsNumber',
    IS_BOOLEAN =  'IsBoolean',
    IS_NUMBER_IN_RANGE = 'IsNumberInRange',
    IS_NOT_NEGATIVE = 'IsNotNegative',
    IS_GREATER_THAN = 'IsGreaterThan',
    IS_GREATER_THAN_OR_EQUAL_TO = 'IsGreaterThanOrEqualTo'
}